exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!simplemde/dist/simplemde.min.css"), "");

// module
exports.push([module.id, "\n.description-editor {\n  width: 100%;\n}\n.description-editor textarea {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n.CodeMirror-fullscreen,\n.editor-toolbar.fullscreen {\n  z-index: 45 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-408ef019","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/saleCreation/components/DescriptionEditor.vue
// module id = 8DyA
// module chunks = 1